import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiChartBar, HiIdentification, HiRefresh, HiChartPie } from 'react-icons/hi';

const DfyBenefitsSection = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const handleQuoteClick = () => navigate('/contactUs');
  const toggleFAQ = index => setOpenIndex(openIndex === index ? null : index);

  const benefits = [
    { icon: HiChartBar, color: 'text-indigo-500', title: 'Targeted Lead Lists', description: 'We use advanced segmentation and Ideal Customer Profiles (ICPs) to build verified lead lists that match your goals.' },
    { icon: HiIdentification, color: 'text-green-500', title: 'Deep Personalization', description: 'Every email is personalized using data points. No vanilla templates. No spam.' },
    { icon: HiRefresh, color: 'text-yellow-500', title: 'End-to-End Outreach', description: 'We manage lead data, personalized emails, delivery, reply forwarding, and reporting — so you don’t have to.' },
    { icon: HiChartPie, color: 'text-pink-500', title: 'Transparent Reporting', description: 'Weekly or monthly reports with opens, replies, warm leads, and next-step suggestions.' },
  ];

  const faqs = [
    { question: 'What do I get with DFY outreach?', answer: 'We handle segmentation, lead qualification, personalized messaging, delivery, response forwarding, and performance reporting — so you don’t have to.' },
    { question: 'Can I approve the messaging before it’s sent?', answer: 'Yes — but optional. We personalize outreach dynamically to maximize results. If you prefer review first, we can share A/B-tested drafts, but this may slow down campaign speed.' },
    { question: 'Do you set up meetings with prospects?', answer: 'We can set up first touch meetings If your campaign is configured that way. We can also forward warm responses directly to you, so your team can take over and schedule meetings.' },
    { question: 'How is this different from other leadgen tools?', answer: 'Most tools send generic blasts. We use deep personalization, real segmentation, and targeted messaging crafted per ICP to ensure quality over quantity. We view lead generation purely through a personalization lens.' },
    { question: 'How soon can my campaign go live?', answer: 'Once we have your ICP and segment preferences, campaigns can typically go live within 3–5 business days.' },
    { question: 'How much does it cost to get a Done For you Campaign?', answer: 'Our Done For You premium campaigns start at $375/month for up to 50 leads with a 3–5 touch sequence and full personalization.Contact us for a custom quote' },
    { question: 'Can I transition into DIY after 3 months of my Done For you Campaign?', answer: 'Yes' },
    
  ];

  return (
    <section className="bg-gray-50 py-8 px-4 sm:py-12 sm:px-6 lg:py-16 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            A Consistent Flow of Warm B2B Leads for sales pipeline—No Heavy Lifting Required
          </h2>
          <p className="mt-4 text-sm sm:text-base md:text-lg text-gray-600 max-w-prose mx-auto">
            You shouldn’t have to choose between endless DIY work or an expensive SDR staff to fuel your sales funnel. With PreciseDraft’s curated outreach, you get a continuous pipeline of ready‑to‑engage leads. We take care of audience targeting, personalized messaging, campaign delivery, and performance analytics, so you can focus on closing deals—on your own terms.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, idx) => {
            const Icon = benefit.icon;
            return (
              <div key={idx} className="bg-white rounded-xl shadow p-6 flex flex-col items-center text-center">
                <Icon className={`w-10 h-10 ${benefit.color}`} />
                <h3 className="mt-4 text-lg sm:text-xl font-semibold text-gray-900">
                  {benefit.title}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-gray-600">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        

        {/* CTA */}
        <div className="text-center mt-4 sm:mt-8">
          <button
            onClick={handleQuoteClick}
            className="inline-block w-full max-w-xs sm:w-auto px-6 py-3 text-sm sm:text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
          >
            Get B2B Leads
          </button>
        </div>

        {/* FAQ Section */}
        <div className="max-w-3xl mx-auto mt-12">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-6">
            FAQs
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-gray-200 pb-4">
                <button
                  onClick={() => toggleFAQ(i)}
                  className="w-full flex justify-between items-center text-left text-sm sm:text-base font-medium text-gray-800 focus:outline-none"
                >
                  {faq.question}
                  <span className="ml-2 text-lg text-indigo-600">
                    {openIndex === i ? '−' : '+'}
                  </span>
                </button>
                {openIndex === i && (
                  <p className="mt-2 text-sm sm:text-base text-gray-700">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DfyBenefitsSection;
